import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configProbe/delete/uptime.configProbe.delete.mutation.gql"
import type {
  UptimeConfigProbeDeleteMutation,
  UptimeConfigProbeDeleteMutationVariables,
} from "@/v2-backoffice-client/uptime/configProbe/delete/__types__/uptime.configProbe.delete.mutation"

type Options = MutationHookOptions<
  UptimeConfigProbeDeleteMutation,
  UptimeConfigProbeDeleteMutationVariables
>

export function useUptimeConfigProbeDeleteMutation(options?: Options) {
  return useMutation<
    UptimeConfigProbeDeleteMutation,
    UptimeConfigProbeDeleteMutationVariables
  >(mutation, {
    refetchQueries: ["UptimeConfigProbeListQuery"],
    awaitRefetchQueries: true,
    ...options,
  })
}
